import {
  FinalSubmissionPayload,
  UnbilledShipmentsFilters,
  UnbilledShipmentsResponse,
} from '@Components/PurchaseInvoiceCreation/types';
import API from '@Services/apiAxios';

export const fetchUnbilledPurchaseShipments = async (
  filters?: UnbilledShipmentsFilters,
): Promise<UnbilledShipmentsResponse> => {
  const params: Record<string, string | Date | string[]> = {};

  if (filters?.fromDate) params.fromDate = filters.fromDate;
  if (filters?.toDate) params.toDate = filters.toDate;
  if (filters?.systems?.length) params.systems = filters.systems;
  if (filters?.carriers?.length) params.carriers = filters.carriers;

  const res = await API.get<UnbilledShipmentsResponse>('invoice/purchase-invoice/unbilled-purchase-shipments', {
    params,
  });

  return res.data;
};

export const getCarriers = async () => {
  const res = await API.get('/organization/carrier');
  return res.data?.data || [];
};

export const createPurchaseInvoice = async (data: FinalSubmissionPayload) => {
  try {
    const payload = {
      shipmentNumbers: data.awbs.map(a => a.number),
      carrierId: data.carrier.id,
      billDate: data.invoiceDate,
      dueDate: data.dueDate,
      carrierReferenceNumber: data.carrierReferenceNumber,
    };

    const response = await API.post('/invoice/purchase-invoice/create-purchase-invoice', payload);
    return response.data;
  } catch (error: any) {
    console.error('Invoice Submission Error:', error.response?.data || error.message);
    throw error;
  }
};

export const createD365PurchaseInvoice = async (data: FinalSubmissionPayload) => {
  try {
    const payload = {
      shipmentNumbers: data.awbs.map(a => a.number),
      carrierId: data.carrier.id,
      billDate: data.invoiceDate,
      dueDate: data.dueDate,
      carrierReferenceNumber: data.carrierReferenceNumber,
    };
    const response = await API.post('/invoice/purchase-invoice/d365/create-purchase-invoice', payload);
    return response.data;
  } catch (error: any) {
    console.error('Invoice Submission Error:', error.response?.data || error.message);
    throw error;
  }
};
